import { defineMessages } from 'react-intl';

export default defineMessages({
  loading: {
    id: 'loading',
    description: 'loading',
    defaultMessage: 'LOADING...',
  },
});
